import { normalizeTemarioNode } from "../../../../utils/temarioTree";

function getRandomUUID() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
    const buf = new Uint8Array(16);
    crypto.getRandomValues(buf);
    buf[6] = (buf[6] & 0x0f) | 0x40;
    buf[8] = (buf[8] & 0x3f) | 0x80;
    const hex = Array.from(buf, (b) => b.toString(16).padStart(2, "0")).join("");
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replaceAll(/[xy]/g, (c) => {
    const r = Math.trunc(Math.random() * 16);
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

function normalizeContenidoEntry(k, v) {
  const key = (k ?? "").trim();
  const arr = Array.isArray(v) ? v : [];
  const norm = arr
    .map((s) => normalizeTemarioNode(s, 0))
    .filter((s) => s !== null);
  return [key, norm];
}

export function normalizeContenidoFromApi(contenidoSrc) {
  return Object.fromEntries(Object.entries(contenidoSrc || {}).map(([k, v]) => normalizeContenidoEntry(k, v)));
}

function pushTestFromTema(testsArr, bloque, tema, td) {
  let preguntas = [];
  if (Array.isArray(td)) {
    preguntas = td;
  } else if (td && typeof td === "object" && Array.isArray(td.preguntas)) {
    preguntas = td.preguntas;
  }
  let tiempoMin = 0;
  if (td && typeof td === "object" && !Array.isArray(td) && td.tiempoPorPregunta != null) {
    const sec = Number(td.tiempoPorPregunta);
    tiempoMin = Number.isFinite(sec) ? Math.round(sec / 60) : 0;
  }
  let preguntasPorIntento = null;
  if (td && typeof td === "object" && !Array.isArray(td) && td.preguntasPorIntento != null) {
    const n = Number(td.preguntasPorIntento);
    preguntasPorIntento = Number.isFinite(n) && n > 0 ? Math.floor(n) : null;
  }
  testsArr.push({
    titulo: tema,
    pestanas: [bloque],
    preguntas,
    tipo: "temario",
    tiempo: tiempoMin,
    preguntasPorIntento,
  });
}

function parseTestsFromObjectShape(testsRaw, testsArr) {
  const obj = testsRaw;
  Object.keys(obj || {}).forEach((bloque) => {
    const temas = obj[bloque];
    if (!temas || typeof temas !== "object") {
      return;
    }
    Object.keys(temas).forEach((tema) => {
      const td = temas[tema];
      pushTestFromTema(testsArr, bloque, tema, td);
    });
  });
}

export function parseTestsArrayFromApi(testsRaw) {
  if (Array.isArray(testsRaw)) {
    return testsRaw;
  }
  const testsArr = [];
  if (testsRaw && typeof testsRaw === "object") {
    parseTestsFromObjectShape(testsRaw, testsArr);
  }
  return testsArr;
}

export function createTabStableIds(pestanasLength) {
  return Array.from({ length: pestanasLength }, () => getRandomUUID());
}

export function assignTestClientKeys(testsArr) {
  const list = Array.isArray(testsArr) ? testsArr : [];
  return list.map((t) => {
    if (t === null || typeof t !== "object") {
      return t;
    }
    const clientKey =
      typeof t.clientKey === "string" && t.clientKey.length > 0 ? t.clientKey : getRandomUUID();
    const preguntas = Array.isArray(t.preguntas)
      ? t.preguntas.map((q) => {
          if (q === null || typeof q !== "object") {
            return q;
          }
          if (typeof q.editorTabKey === "string" && q.editorTabKey.length > 0) {
            return { ...q };
          }
          return { ...q, editorTabKey: getRandomUUID() };
        })
      : t.preguntas;
    return { ...t, clientKey, preguntas };
  });
}
